import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post("/login", {
        username,
        password,
      })
      .then((res) => {
        const token = res.data.data?.token;

        const userInformation = res.data.data?.userInformation;

        const userId = userInformation?.id;
        const fullName = userInformation?.full_name || "";
        const email = userInformation?.email || "";
        const numberPhone = userInformation?.phone_number || "";
        const address = userInformation?.address || "";
        const avatarUrl = userInformation?.avatar_url || "";
        const userAddresses = userInformation?.userAddresses || [];

        localStorage.setItem("accessToken", token);
        localStorage.setItem("avatar_url", avatarUrl);
        localStorage.setItem("userId", userId);
        localStorage.setItem("fullName", fullName);
        localStorage.setItem("email", email);
        localStorage.setItem("numberPhone", numberPhone);
        localStorage.setItem("address", address);
        localStorage.setItem("userAddresses", JSON.stringify(userAddresses));

        navigate("/");
        toast.success("Đăng nhập thành công");
        window.location.reload();
        clearField();
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.status == 422) {
          toast.error("Tên đăng nhập hoặc mật khẩu không đúng");
        }
      });
  };

  const clearField = () => {
    setUsername("");
    setPassword("");
  };

  const handleGoogleLogin = () => {
    axios
      .get("/customer/auth/google/redirect")
      .then((res) => {
        window.open(
          res.data.data,
          "_blank",
          "width=800,height=600,left=200,top=100",
        );
      })
      .catch((err) => {
        toast.error("Đăng nhập Google thất bại");
        console.log(err);
      });
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "loginStatus") {
        navigate("/");
        toast.success("Đăng nhập thành công");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="login-container">
        <h2>Đăng Nhập</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Tên đăng nhập"
            value={username}
            required
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            placeholder="Mật khẩu"
            value={password}
            required
            autoComplete="off"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Đăng Nhập</button>
        </form>

        <div className="mt-3">
          <button
            style={{
              backgroundColor: "#fff",
              color: "#000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #000",
              padding: "5px 0 5px 0",
              fontSize: "15px",
            }}
            onClick={handleGoogleLogin}
          >
            <img
              src="/img/google-logo.jpg"
              style={{ width: "40px", height: "40px" }}
            />
            <div>Đăng nhập bằng google</div>
          </button>
        </div>

        <div className="footer-login">
          Chưa có tài khoản? <Link to={"/signup"}>Đăng ký</Link>
        </div>
      </div>
    </div>
  );
};
